import { render, staticRenderFns } from "./tmOverlaySprite.vue?vue&type=template&id=acfb26b6&"
import script from "./tmOverlaySprite.vue?vue&type=script&lang=js&"
export * from "./tmOverlaySprite.vue?vue&type=script&lang=js&"
import style0 from "./tmOverlaySprite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports